import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useInventory } from '../context/InventoryContext';
import CategoryForm from '../components/categories/CategoryForm';
import Button from '../components/ui/Button';

const CategoryDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { getCategoryById } = useInventory();
  
  const category = id ? getCategoryById(id) : undefined;
  const isNewCategory = id === 'new';
  
  if (!isNewCategory && !category) {
    return (
      <div className="text-center py-12">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Category Not Found</h2>
        <p className="text-gray-500 mb-6">The category you're looking for doesn't exist.</p>
        <Button onClick={() => navigate('/categories')}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Categories
        </Button>
      </div>
    );
  }
  
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" onClick={() => navigate('/categories')}>
          <ArrowLeft className="h-4 w-4 mr-1" />
          Back
        </Button>
        <h1 className="text-2xl font-bold text-gray-900">
          {isNewCategory ? 'Add New Category' : `Edit Category: ${category?.name}`}
        </h1>
      </div>
      
      <CategoryForm 
        category={category} 
        isEdit={!isNewCategory} 
      />
    </div>
  );
};

export default CategoryDetailPage;